import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import { formatDateWithTime } from '@ami/react/core';
import { Button } from 'reactstrap';

const DownloadRevisionPdfButton = ({
  onClick,
  revisionNumber,
  revisionNumberDownloading,
}) => {
  const isDownloading = revisionNumber === revisionNumberDownloading;
  return (
    <Button
      title={
        isDownloading ? 'Downloading Revision PDF' : 'Download Revision PDF'
      }
      className="btn btn-outline-primary btn-xs"
      onClick={onClick}
    >
      {isDownloading && (
        <span>
          Downloading PDF <i className="fa fa-spin fa-spinner" />
        </span>
      )}
      {!isDownloading && (
        <span>
          Download Revision #{revisionNumber} PDF{' '}
          <i className="fa fa-download" />
        </span>
      )}
    </Button>
  );
};

class Activity extends React.Component {
  constructor(props) {
    super(props);
    this.showDetails = this.showDetails.bind(this);
    this.state = { showDetails: false };
  }

  showDetails() {
    this.setState({ showDetails: true });
  }
  render() {
    const { activity, onDownloadRevisionPdf, revisionNumberDownloading } =
      this.props;
    return (
      <tr>
        <td className="text-break-line">
          {activity.description}
          {activity.details && !this.state.showDetails && (
            <button
              type="button"
              className="btn btn-link ps-1 pt-1 mt-0"
              onClick={this.showDetails}
            >
              + expand
            </button>
          )}
          {activity.details && this.state.showDetails && (
            <div>{activity.details}</div>
          )}
        </td>
        <td>{activity.userName}</td>
        <td>{formatDateWithTime(activity.date)}</td>
        <td>
          {activity.oldRevisionNumber !== activity.newRevisionNumber ? (
            <DownloadRevisionPdfButton
              onClick={onDownloadRevisionPdf}
              revisionNumberDownloading={revisionNumberDownloading}
              revisionNumber={activity.newRevisionNumber}
            />
          ) : (
            'Revision Unchanged'
          )}
        </td>
      </tr>
    );
  }
}
export default class OrderActivitiesComponent extends React.Component {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
  };

  state = {
    revisionNumberDownloading: null,
  };

  downloadRevisionPdf(revisionNumber) {
    this.setState({ revisionNumberDownloading: revisionNumber });
    this.props.order
      .getRevisionPdfDownloadUrl(revisionNumber)
      .then((response) => (window.location = response.url))
      .catch(() => {})
      .finally(() => this.setState({ revisionNumberDownloading: null }));
  }

  render() {
    const { order } = this.props;
    return (
      <div className="col">
        <div className="card mb-3 box-shadow">
          <div className="card-body">
            <h6 className="card-title text-center">Activity</h6>
            <table className="table table-mobile">
              <thead>
                <tr>
                  <th>Event</th>
                  <th>User</th>
                  <th>Date</th>
                  <th>Revision</th>
                </tr>
              </thead>
              <tbody>
                {order.activities
                  .slice(0)
                  .reverse()
                  .map((activity, i) => (
                    <Activity
                      key={order.activities.length - i}
                      revisionNumberDownloading={
                        this.state.revisionNumberDownloading
                      }
                      onDownloadRevisionPdf={() =>
                        this.downloadRevisionPdf(activity.newRevisionNumber)
                      }
                      activity={activity}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
